import {defineDecimalPlaces} from "./get-decimal-places";

export const round = (num, currency) => {
    const degree = defineDecimalPlaces(currency)
    num = +num;
    if(isNaN(num)) return "";
    return parseFloat(num.toFixed(degree));
};
